{
  "version": 1,
  "asset_id": "032b0e86-b887-4c47-962f-eba04c78b181",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/032b0e86-b887-4c47-962f-eba04c78b181/hensel.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/032b0e86-b887-4c47-962f-eba04c78b181/hensel.png",
  "original_filename": "hensel.png",
  "size": 42259,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:44Z"
}
